import { TimeStatus } from '@/models/generated/graphql'
import { cn } from '@/utils/helpers'
import { getInitials } from '@/utils/string.utils'

type AppointmentStatusProps = {
  timeStatus: TimeStatus
  participantName: string
  participantAvatar?: string
  isParticipantPresent: boolean
  className?: string
}

export const AppointmentStatus = ({
  timeStatus,
  participantName,
  participantAvatar,
  isParticipantPresent,
  className
}: AppointmentStatusProps) => {
  if (timeStatus === TimeStatus.Future) {
    return (
      <div className={cn('flex flex-col items-center gap-3', className)}>
        <p className="text-center font-light">
          Vous pourrez rejoindre la visio 10 minutes avant
          <br />
          le début du rendez-vous
        </p>
      </div>
    )
  }

  if (timeStatus === TimeStatus.Past) {
    return (
      <div className={cn('flex flex-col items-center gap-3', className)}>
        <p className="text-center">Ce rendez-vous est terminé</p>
      </div>
    )
  }

  // Current state
  return (
    <div className={cn('flex flex-col items-center gap-3', className)}>
      {/* Avatar */}
      {isParticipantPresent && (
        <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-full bg-surface-tertiary">
          {participantAvatar ? (
            <img src={participantAvatar} alt={participantName} className="h-full w-full object-cover" />
          ) : (
            <span className="text-lg font-semibold text-primary">{getInitials(participantName)}</span>
          )}
        </div>
      )}

      {/* Status */}
      <p className="text-center">
        {isParticipantPresent ? `${participantName} est déjà là` : 'Vous êtes le premier arrivé'}
      </p>
    </div>
  )
}
